export const MuiFormControl = () => {
  return {
    styleOverrides: {
      root: {
        width: '100%',
      },
    },
  };
};
